export default __webpack_public_path__ + "static/media/descarga.be06cbf2.svg";